import reporter from 'privates/reporter';
import {generateError} from 'privates/validations/errors';
import isNil from 'lodash/isNil';

const VECTOR_MEDIA_SRC_REGEX = /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]+)?$/;

function extractModelDataFromSrc(src) {
    if (VECTOR_MEDIA_SRC_REGEX.test(src)) {
        const [, svgId, title] = src.match(VECTOR_MEDIA_SRC_REGEX) || [0, src];

        const decodedTitle = title ? decodeURIComponent(title) : '';
        return {svgId, title: decodedTitle};
    }

    return null;
}

function convertToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    const svgData = extractModelDataFromSrc(src);
    if (!svgData) {
        const error = !isNil(index) ? generateError.error_bad_svg_format_with_index : generateError.error_bad_svg_format;
        reporter.reportSdkError(error({
            propertyName,
            functionName,
            index,
            wrongValue: src
        }));
        return null;
    }
    return svgData;
}

function buildFullUrlFromSvgId(svgId, title) {
    if (!svgId) {
        return null;
    }
    const encodedTitle = title ? encodeURIComponent(title) : '';
    return `wix:vector://v1/${svgId}/${encodedTitle}`;
}

export default {
    VECTOR_MEDIA_SRC_REGEX,
    extractModelDataFromSrc,
    convertToModelFormatAndReportIfError,
    buildFullUrlFromSvgId
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/vectorImageUtils.es6